export default __webpack_public_path__ + "static/media/plans_example.90937339.png";